import { AiSparkles } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { generateAutomationName } from "app/pages/activation/helpers/generateAutomationName";

import { InsightsLoadingRotatingSubtitle } from "./InsightsLoadingRotatingSubtitle";
import * as SC from "./styles";
import { INSIGHTS_SECTION_SUBTITLE, INSIGHTS_SECTION_TITLE } from "./texts";

type InsightsTitleProps = {
    isPanelOpen: boolean;
    isLoading?: boolean;
};

export const InsightsTitle = ({ isPanelOpen, isLoading = false }: InsightsTitleProps) => (
    <Flex
        gap="12px"
        alignItems="center"
        flex={1}
    >
        <Flex
            alignItems="center"
            gap="4px"
            flexShrink={0}
        >
            <AiSparkles
                size="sm"
                color={colorsPalettes.carbon[500]}
            />

            <Text
                fontVariant="h5_2"
                color={colorsPalettes.carbon[500]}
            >
                {translate(INSIGHTS_SECTION_TITLE)}
            </Text>
        </Flex>

        {isLoading ? (
            <InsightsLoadingRotatingSubtitle />
        ) : (
            <SC.InsightsSubtitleReveal $visible={!isPanelOpen}>
                <SC.InsightsSubtitleText
                    data-automation={generateAutomationName("home", ["insights", "panel", "subtitle"])}
                >
                    {translate(INSIGHTS_SECTION_SUBTITLE)}
                </SC.InsightsSubtitleText>
            </SC.InsightsSubtitleReveal>
        )}
    </Flex>
);
